import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';
import { BxLogger } from '../../../../core/services/bx-logger.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { JobsInvoiceSettingsService } from '../../../../data/repositories/jobs/jobs-invoice-settings.service';

@Component({
    selector: 'app-order-terms',
    templateUrl: './order-terms.component.html',
    styleUrls: ['./order-terms.component.scss'],
    standalone: false,
})
export class OrderTermsComponent implements OnInit {
    // @ts-ignore TS2564
    title: string;
    type = 'purchase';
    termsAndConds = {
        orderTerms: '',
        orderTermsContractor: '',
        orderTermsWork: '',
        isTermsOnSeparatePage: false,
    };
    isShowingSupplierTerms = true;
    isShowingContractorTerms = false;
    action = new EventEmitter();

    constructor(
        private bsModalRef: BsModalRef,
        private dialogService: DialogService,
        private logger: BxLogger,
        private jobsSettingsService: JobsInvoiceSettingsService
    ) {}

    ngOnInit(): void {
        this.title = (this.type === 'purchase' ? 'Purchase' : 'Work') + ' Order Terms and Conditions';

        this.jobsSettingsService
            .getOrderTermsAndConditions()
            .pipe(take(1))
            .subscribe((res) => {
                if (res.data?.orderTermsAndConditions) {
                    this.termsAndConds = {
                        orderTerms: res.data.orderTermsAndConditions?.orderTerms || '',
                        orderTermsContractor: res.data.orderTermsAndConditions?.orderTermsContractor || '',
                        orderTermsWork: res.data.orderTermsAndConditions?.orderTermsWork || '',
                        isTermsOnSeparatePage: res.data.orderTermsAndConditions?.isTermsOnSeparatePage || false,
                    };
                }
            });
    }

    ok() {
        this.jobsSettingsService
            .updateOrderTermsAndConditions(
                this.termsAndConds.isTermsOnSeparatePage,
                this.termsAndConds.orderTerms,
                this.termsAndConds.orderTermsContractor,
                this.termsAndConds.orderTermsWork
            )
            .pipe(take(1))
            .subscribe((res) => {
                if (res.data?.updateOrderTermsAndConditions) {
                    this.termsAndConds = {
                        orderTerms: res.data?.updateOrderTermsAndConditions.orderTerms || '',
                        orderTermsContractor: res.data?.updateOrderTermsAndConditions.orderTermsContractor || '',
                        orderTermsWork: res.data?.updateOrderTermsAndConditions.orderTermsWork || '',
                        isTermsOnSeparatePage: res.data?.updateOrderTermsAndConditions?.isTermsOnSeparatePage || false,
                    };

                    this.logger.success('Terms and conditions saved');
                    this.bsModalRef.hide();
                    this.action.emit({ cancelled: false });
                }
            });
    }

    showSupplierTerms() {
        this.isShowingContractorTerms = false;
        this.isShowingSupplierTerms = true;
    }

    showContractorTerms() {
        this.isShowingContractorTerms = true;
        this.isShowingSupplierTerms = false;
    }

    cancel() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: true });
    }

    resetOrderTermsSettings() {
        const params = {
            title: 'Reset Terms and Conditions?',
            text: 'Click OK to reset terms and conditions back to their original settings.',
        };
        this.dialogService.show(params).then(
            () => {
                this.jobsSettingsService
                    .getOrderTermsAndConditions()
                    .pipe(take(1))
                    .subscribe((res) => {
                        if (res.data?.orderTermsAndConditions) {
                            if (this.type === 'work') {
                                this.termsAndConds.orderTermsWork = res.data.orderTermsAndConditions?.orderTermsWork || '';
                            }

                            if (this.type === 'purchase') {
                                this.termsAndConds.orderTerms = res.data.orderTermsAndConditions?.orderTerms || '';
                                this.termsAndConds.orderTermsContractor = res.data.orderTermsAndConditions?.orderTermsContractor || '';
                            }
                        }
                    });
            },
            () => {}
        );
    }
}
